const systemEvents = {
    namespaced: true,
    state: {
        systemEventsList: [],
        severityLevelsList: []
    },
    mutations: {
        setSystemEventsList( state , newList ) {
            state.systemEventsList = newList
        },
        setSeverityLevelsList( state , newList ) {
            state.severityLevelsList = newList
        }
    },
    actions: {
        updateSystemEventsList(context, dateParams) {
            this._vm.$traveller_http.get('/traveller/restui/systemevent/getAllEvents',
                { params: { "startDate": dateParams.startDate, "endDate" : dateParams.endDate } })
                .then(response => {
                    if( response.status == 200 && response && Array.isArray(response.data)) {
                        context.commit('setSystemEventsList', response.data);
                    }
                }).catch( () => {
                    console.log("Error getting systemEventsList");
                })
        },
        updateSeverityLevelsList(context) {
            this._vm.$traveller_http.get('/traveller/restui/systemevent/getSeverityLevels')
                .then(response => {
                    if( response.status == 200 && response && Array.isArray(response.data)) {
                        context.commit('setSeverityLevelsList', response.data);
                    }
                }).catch( () => {
                    console.log("Error getting severityLevelsList");
                })
        },
        setSystemEventAck(context, params) {
            this._vm.$traveller_http.put('/traveller/restui/systemevent/updateSystemEventAck', null, {
                headers: {
                  'Content-Type': 'application/json;charset=UTF-8'
                },
                params: {id: params.id, ack: params.ack}
            });
            
            let systemEvents = this.state.systemEvents.systemEventsList;
            if(Array.isArray(systemEvents) && params && params.id) {
                let idx = systemEvents.findIndex(event => event.id === params.id);
                let newEvent = systemEvents[idx];
                newEvent.acknowledgementType = params.ack;
                systemEvents[idx] = newEvent;
                context.commit('setSystemEventsList', systemEvents);
            }
        }

    }
}

export default systemEvents;